import { get } from './utils';

export async function getNichesReport(data) {
  return get(`/niches/analysic`, data);
}
